document.addEventListener("click", function (e) {
  const trigger = e.target.closest("[data-zoom-modal-trigger]");
  if (!trigger) return;

  const productInfo = e.target.closest("product-info");
  if (!productInfo) return;

  if (!productInfo.hasAttribute("data-zoom-modal")) return;

  const img = trigger.querySelector("img");
  if (!img) return;

  const sectionId = productInfo.dataset.section;
  const modal = document.getElementById("ImageZoomModal-" + sectionId);
  const target = document.getElementById("ImageZoomTarget-" + sectionId);

  if (!modal || !target) return;

  target.src = img.src;
  modal.classList.add("is-open");
});

document.addEventListener("click", function (e) {
  if (
    e.target.closest(".image-zoom-modal__bg") ||
    e.target.closest(".image-zoom-modal__close")
  ) {
    const modal = e.target.closest(".image-zoom-modal");
    if (modal) modal.classList.remove("is-open");
  }
});
document.addEventListener("click", function (e) {
  if (e.target.matches(".image-zoom-modal__bg")) {
    const modal = e.target.closest(".image-zoom-modal");
    modal.classList.remove("is-open");
  }
   // コンテンツ以外（＝背景）をクリックしたら閉じる
  const content = modal.querySelector(".image-zoom-modal__content");
  if (!content.contains(e.target)) {
    modal.classList.remove("is-open");
  }
});
